import { Breadcrumb, Button, Divider, Flex, Pagination, Table } from "antd";
import { Link } from "react-router-dom";
import { HomeOutlined, PlusCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import { useState } from 'react';
import GroupService from '../../services/widgetData'
import { useParams } from 'react-router-dom';

const columns = [
    {
        title: 'id',
        dataIndex: 'id',
        render: (text, record) => {
            let url = "/widget/"+record.id_widget+"/widgetdata/" + record.id;
            return <Link to={url ?? ""}>{text}</Link>;
        }
    },
  ];

const WidgetsData = () => {
    const params = useParams();
    const [total, setTotal] = useState(0)
    const [page, setPage] = useState(0)
    const [data, setData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([])
    const [columns, setColumns] = useState([]);

    const update = (idWidget) => {
        GroupService.list({
            id_widget: idWidget,
            page: page
        })
        .then(response => {
            for (let i = 0; i < response.data.List.length; i++) {
                response.data.List[i].key = response.data.List[i].id
            }

            const newData = response.data.List;

            setData(newData)
            setTotal(response.data.Total)

            if (newData.length > 0 && newData[0].fields_data) {
                const fields = Object.keys(newData[0].fields_data);  // Получаем все ключи (названия полей)
                const dynamicColumns = fields.map(field => ({
                    title: field,  // Название колонки - это ключ поля
                    render: (text, record) => {
                        // Используем ключ для получения значения из объекта fields_data
                        return record.fields_data[field] ?? '-'; // Если значения нет, выводим дефолтное значение
                    }
                }));

                setColumns([
                    {
                        title: 'id',
                        dataIndex: 'id',
                        render: (text, record) => {
                            let url = "/widget/"+record.id_widget+"/widgetdata/" + record.id;
                            return <Link to={url ?? ""}>{text}</Link>;
                        }
                    },
                    ...dynamicColumns,
                ]);
            }            
        })
        .catch(e => {
        });
    }

    useEffect(() => {
        const idAsNumber = parseInt(params.id, 10);
        update(idAsNumber);
    }, [page]);

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            let rows = [];
            for (let i = 0; i < selectedRows.length; i++) {
                rows.push(selectedRows[i].id)
            }

            setSelectedRows(rows)
        },
        getCheckboxProps: (record) => {
            console.log(record);
            return {
                id: record.id  // возвращаем id для каждого чекбокса
            };
        }
    };    

    return (
        <>
            <div style={{paddingTop: '20px'}}>
                <Breadcrumb
                    separator=""
                    items={[
                        {
                            href: '/',
                            title: <HomeOutlined />,
                        },
                        {
                            type: 'separator',
                        },                    
                        {
                            href: '/widgets',
                            title: 'Виджеты',
                        },
                        {
                            type: 'separator',
                        },
                        {
                            href: `/widget/${params.id}/widgetsdata`,
                            title: 'Данные',
                        }
                    ]}
                />
                </div>

            <Divider />

            <Flex gap="small" wrap="wrap">
            <Link to={`/widget/${params.id}/widgetdata`}>
                <Button type="primary" icon={<PlusCircleOutlined />} size='large' />
            </Link>
            <Button 
                type="primary" 
                icon={<DeleteOutlined />} 
                size='large' 
                onClick={(e) => {
                    GroupService.delete({
                        ids: selectedRows
                    })
                    .then(response => {
                        if (response.status == 200) {
                            const idAsNumber = parseInt(params.id, 10);
                            update(idAsNumber);
                        }
                    })
                    .catch(e => {
                    });
                }}
            />
            </Flex>

            <Divider />

            <Table 
                rowSelection={{
                    type: 'multiple',
                    ...rowSelection,
                }}
                dataSource={data}
                style={{overflow: 'scroll'}}
                bordered={true}
                pagination={false}
                columns={columns}
            />

            <div
                style={{
                    textAlign: 'right',
                    paddingTop: '20px',
                    paddingBottom: '20px'
                }}
            >
            <Pagination 
                hideOnSinglePage={true}
                defaultCurrent={1} 
                total={total} 
                defaultPageSize={8} 
                onChange={(page) => {
                    setPage(page-1)
                }}
                current={page+1}
            />
            </div>
        </>
    )
}

export default WidgetsData;   